import { Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

type StoreItemAreaTemporarySkeletonProps = {
  responsive?: boolean
}

export const StoreItemAreaTemporarySkeleton: FC<StoreItemAreaTemporarySkeletonProps> =
  ({ responsive = false }) => (
    <Stack spacing={1} width={responsive ? { xs: 80, md: 108 } : 80}>
      <Skeleton variant="rectangular" sx={{ width: 60, height: 80 }} />
      <SkeletonText variant="overline" width="60%" />
      <SkeletonText variant="overline" width="60%" />
    </Stack>
  )
